import { render, staticRenderFns } from "./ManageModifiers.vue?vue&type=template&id=9605ea54&scoped=true&"
import script from "./ManageModifiers.vue?vue&type=script&lang=js&"
export * from "./ManageModifiers.vue?vue&type=script&lang=js&"
import style0 from "./ManageModifiers.vue?vue&type=style&index=0&id=9605ea54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9605ea54",
  null
  
)

export default component.exports